<div class="example-container">
  <h1 mat-dialog-title>Paramétrage</h1>
  <form [formGroup]="instanceForm">
    <mat-tab-group>
      <mat-tab label="Principal">
        <div class="tab-content">
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Entrepôt</mat-label>
              <mat-select
                i18n-placeholder
                placeholder="Unité Prod"
                formControlName="UniteProd"
              >
                @if (entrepots$ | async; as entrepots) {
                  <mat-option>
                    {{ null }}
                  </mat-option>
                  @for (item of entrepots.Items; track item) {
                    <mat-option [value]="item.Entrepot">
                      {{ item.Entrepot }}
                    </mat-option>
                  }
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="user-field-container" [hidden]="true">
            <mat-form-field appearance="fill">
              <mat-label>Centre</mat-label>
              <mat-select
                i18n-placeholder
                placeholder="Centre"
                formControlName="Centre"
              >
                @if (centres$ | async; as centres) {
                  <mat-option>
                    {{ null }}
                  </mat-option>
                  @for (item of centres.Items; track item) {
                    <mat-option [value]="item.Centre">
                      {{ item.Centre }}
                    </mat-option>
                  }
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="user-field-container" [hidden]="true">
            <mat-form-field appearance="fill">
              <mat-label>Poste</mat-label>
              <mat-select
                i18n-placeholder
                placeholder="Poste"
                formControlName="Poste"
              >
                <mat-option>
                  {{ null }}
                </mat-option>
                @if (postes$ | async; as postes) {
                  @for (item of postes.Items; track item) {
                    <mat-option [value]="item.Poste">
                      {{ item.Poste }}
                    </mat-option>
                  }
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="user-field-container" [hidden]="true">
            <mat-form-field appearance="fill">
              <mat-label>Ressource</mat-label>
              <mat-select
                i18n-placeholder
                placeholder="Ressource"
                formControlName="Ressource"
              >
                @if (ressources$ | async; as ressources) {
                  <mat-option>
                    {{ null }}
                  </mat-option>
                  @for (item of ressources.Items; track item) {
                    <mat-option [value]="item.Ressource">
                      {{ item.Ressource }}
                    </mat-option>
                  }
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="user-field-container" [hidden]="true">
            <mat-form-field appearance="fill">
              <mat-label>Num Client</mat-label>
              <input matInput type="text" formControlName="NumClient" />
            </mat-form-field>
          </div>
          <div class="user-field-container" [hidden]="true">
            <mat-form-field appearance="fill">
              <mat-label>Num Affaire</mat-label>
              <input matInput type="text" formControlName="NumAffaire" />
            </mat-form-field>
          </div>
          <div class="user-field-container" [hidden]="true">
            <mat-form-field appearance="fill">
              <mat-label>Hor Jour</mat-label>
              <input matInput type="number" formControlName="HorJour" />
            </mat-form-field>
          </div>
          <div class="user-field-container" [hidden]="true">
            <mat-form-field appearance="fill">
              <mat-label>Hor Semaine</mat-label>
              <input matInput type="number" formControlName="HorSemaine" />
            </mat-form-field>
          </div>
          <div class="user-field-container" [hidden]="true">
            <mat-form-field appearance="fill">
              <mat-label>Hor Mois</mat-label>
              <input matInput type="number" formControlName="HorMois" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-checkbox formControlName="OfFerme">Of Ferme</mat-checkbox>
          </div>
          <div class="user-field-container">
            <mat-checkbox formControlName="OfLance">Of Lancé</mat-checkbox>
          </div>
          <div class="user-field-container">
            <mat-checkbox formControlName="OfPrevu">Of prévu</mat-checkbox>
          </div>
          <div class="user-field-container">
            <mat-checkbox formControlName="OfEncours">Of en cours</mat-checkbox>
          </div>
          <div class="user-field-container" [hidden]="true">
            <mat-form-field appearance="fill">
              <mat-label>Règle</mat-label>
              <input matInput formControlName="Regle" />
            </mat-form-field>
          </div>
          <div class="user-field-container" [hidden]="true">
            <mat-form-field appearance="fill">
              <mat-label>Num Of</mat-label>
              <input matInput type="text" formControlName="NumOf" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Tri des Ofs</mat-label>
              <mat-select formControlName="RegleTriof">
                <mat-option>
                  {{ null }}
                </mat-option>
                @for (regle of triOf; track regle) {
                  <mat-option [value]="regle.value">
                    {{ regle.viewValue }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-checkbox formControlName="NonVisuop">Non visu Op</mat-checkbox>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Numéro Batch Défaut</mat-label>
              <mat-select i18n-placeholder formControlName="BatchDefaut">
                @if (batchs$ | async; as batchs) {
                  <mat-option>
                    {{ null }}
                  </mat-option>
                  @for (item of batchs.Items; track item) {
                    <mat-option [value]="item.NumBatch">
                      {{ item.NumBatch + " - " + item.DescCourte }}
                    </mat-option>
                  }
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Expression Réalisé</mat-label>
              <mat-select formControlName="ExpressRealise">
                <mat-option>
                  {{ null }}
                </mat-option>
                @for (regle of realise; track regle) {
                  <mat-option [value]="regle.value">
                    {{ regle.viewValue }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="user-field-container" [hidden]="true">
            <mat-form-field appearance="fill">
              <mat-label>Format Date</mat-label>
              <input matInput type="text" formControlName="FormatDate" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Article Defaut</mat-label>
              <input matInput formControlName="ArticleDefaut" />
            </mat-form-field>
          </div>

          <div class="user-field-container" [hidden]="true">
            <mat-checkbox formControlName="AffectResop"
              >Affectation Ressources OP</mat-checkbox
            >
          </div>
          <div class="user-field-container">
            <mat-checkbox formControlName="GestDispoComposof" [hidden]="true"
              >Gestion graphique dispo composants</mat-checkbox
            >
          </div>
          <div class="user-field-container" [hidden]="true">
            <mat-checkbox formControlName="ShowRessources"
              >Montrer ressources</mat-checkbox
            >
          </div>
          <div class="user-field-container">
            <mat-checkbox formControlName="HideOfTask">Cacher Ofs</mat-checkbox>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Code couleur marqueur du jour courant</mat-label>
              <input matInput type="color" formControlName="TodayMarkerColor" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Code couleur de la semaine courante</mat-label>
              <input matInput type="color" formControlName="CurrentWeekColor" />
            </mat-form-field>
          </div>

          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label
                >Nombre de champs user à afficher sur l'onglet principal de
                l'opération</mat-label
              >
              <input matInput formControlName="NbChampsUserOpOnMainTab" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Couleur de fond Op</mat-label>
              <input matInput type="color" formControlName="OpBackground" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Couleur de fond Of</mat-label>
              <input matInput type="color" formControlName="OfBackground" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Couleur de fond Centre</mat-label>
              <input matInput type="color" formControlName="CentreBackground" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Couleur de fond Poste</mat-label>
              <input matInput type="color" formControlName="PosteBackground" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Couleur de fond Entrepôt</mat-label>
              <input matInput type="color" formControlName="EntBackground" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Couleur texte Of</mat-label>
              <input matInput type="color" formControlName="OfTextcolor" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Couleur texte Op</mat-label>
              <input matInput type="color" formControlName="OpTextcolor" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Couleur texte Centre</mat-label>
              <input matInput type="color" formControlName="CentreTextcolor" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Couleur texte Poste</mat-label>
              <input matInput type="color" formControlName="PosteTextcolor" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Couleur texte Entrepôt</mat-label>
              <input matInput type="color" formControlName="EntTextcolor" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Hauteur ligne Entrepôt</mat-label>
              <input matInput type="number" formControlName="RowHeightEnt" />
            </mat-form-field>
          </div>

          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Hauteur ligne Centre</mat-label>
              <input matInput type="number" formControlName="RowHeightCent" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Hauteur ligne Poste</mat-label>
              <input matInput type="number" formControlName="RowHeightPoste" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Hauteur ligne Of</mat-label>
              <input matInput type="number" formControlName="RowHeight" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Hauteur ligne Opérations</mat-label>
              <input matInput type="number" formControlName="RowHeightOp" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Couleur fond Of Prévu</mat-label>
              <input matInput type="color" formControlName="OfPBackground" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Couleur fond Of Ferme</mat-label>
              <input matInput type="color" formControlName="OfFBackground" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Couleur fond Of En cours</mat-label>
              <input matInput type="color" formControlName="OfEBackground" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Couleur fond Of Lancé</mat-label>
              <input matInput type="color" formControlName="OfLBackground" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Couleur texte Of Prévu</mat-label>
              <input matInput type="color" formControlName="OfPTextcolor" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Couleur texte Of Ferme</mat-label>
              <input matInput type="color" formControlName="OfFTextcolor" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Couleur texte Of En cours</mat-label>
              <input matInput type="color" formControlName="OfETextcolor" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Couleur texte Of Lancé</mat-label>
              <input matInput type="color" formControlName="OfLTextcolor" />
            </mat-form-field>
          </div>
          <br />
          <mat-divider></mat-divider>
          <br />
          <div class="text-formula-container">
            <div class="user-field-container" style="flex: 1; width: 50%">
              <mat-form-field appearance="fill" style="width: 100%">
                <mat-label>Formule texte Of</mat-label>
                <textarea
                  rows="5"
                  matInput
                  formControlName="TextOfFormula"
                ></textarea>
              </mat-form-field>
            </div>
            <div class="user-field-container" style="flex: 1; width: 50%">
              <mat-form-field appearance="fill" style="width: 100%">
                <mat-label>Formule texte Op</mat-label>
                <textarea
                  rows="5"
                  matInput
                  formControlName="TextOpFormula"
                ></textarea>
              </mat-form-field>
            </div>
          </div>
          <div class="text-formula-container">
            <div class="user-field-container" style="flex: 1; width: 25%">
              <mat-form-field appearance="fill" style="width: 100%">
                <mat-label>Texte à gauche de l'of</mat-label>
                <textarea
                  rows="5"
                  matInput
                  formControlName="OfLeftsideText"
                ></textarea>
                <mat-icon
                  matSuffix
                  color="primary"
                  matTooltip="'Ex: 'Article: ' || DescCourte || ' - ' || DescLongue"
                  >help_outline</mat-icon
                >
              </mat-form-field>
            </div>
            <div class="user-field-container" style="flex: 1; width: 25%">
              <mat-form-field appearance="fill" style="width: 100%">
                <mat-label>Texte à droite de l'of</mat-label>
                <textarea
                  rows="5"
                  matInput
                  formControlName="OfRightsideText"
                ></textarea>
              </mat-form-field>
            </div>
            <div class="user-field-container" style="flex: 1; width: 25%">
              <mat-form-field appearance="fill" style="width: 100%">
                <mat-label>Texte à gauche de l'opération</mat-label>
                <textarea
                  rows="5"
                  matInput
                  formControlName="OpLeftsideText"
                ></textarea>
              </mat-form-field>
            </div>
            <div class="user-field-container" style="flex: 1; width: 25%">
              <mat-form-field appearance="fill" style="width: 100%">
                <mat-label>Texte à droite de l'opération</mat-label>
                <textarea
                  rows="5"
                  matInput
                  formControlName="OpRightsideText"
                ></textarea>
              </mat-form-field>
            </div>
          </div>
          <div class="text-formula-container">
            <div class="user-field-container">
              <mat-checkbox formControlName="TooltipOf"
                >Afficher l'Info Bulle sur les Ofs</mat-checkbox
              >
            </div>
            <div class="user-field-container" style="flex: 1; width: 25%">
              <mat-form-field appearance="fill" style="width: 100%">
                <mat-label>Contenu Info Bulle Of</mat-label>
                <textarea
                  rows="15"
                  matInput
                  formControlName="TooltipContentOf"
                ></textarea>
              </mat-form-field>
            </div>
            <div class="user-field-container">
              <button mat-stroked-button (click)="formatJson()">
                Formatter JSON
              </button>
            </div>
          </div>

          <div class="user-field-container">
            <mat-form-field [hidden]="true" appearance="fill">
              <mat-label>SeqCalcCharges</mat-label>
              <input matInput formControlName="SeqCalcCharges" />
            </mat-form-field>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Règles Détail OP">
        <div class="tab-content">
          @for (indice of indicesUserfields; track indice) {
            <div class="user-field-container">
              <div>
                <mat-form-field>
                  <mat-label>{{ "Titre Champ User " + indice }}</mat-label>
                  <input
                    matInput
                    type="text"
                    [formControlName]="'TitreUser' + indice"
                  />
                </mat-form-field>
              </div>
              <div>
                <mat-form-field appearance="fill">
                  <mat-label>{{ "Règle User " + indice }}</mat-label>
                  <mat-select
                    i18n-placeholder
                    [placeholder]="'Règle User ' + indice"
                    [formControlName]="'RegleUser' + indice"
                  >
                    @if (regles$ | async; as regles) {
                      <mat-option>
                        {{ null }}
                      </mat-option>
                      @for (item of regles.Items; track item) {
                        <mat-option [value]="item.NumRegle">
                          {{ item.NumRegle }}
                        </mat-option>
                      }
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          }
        </div>
      </mat-tab>
      <mat-tab label="Procédures Oracle">
        <div class="tab-content">
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Procédure Oracle</mat-label>
              <input matInput formControlName="ProcedureOracle" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Param1ProcOracle</mat-label>
              <input matInput type="text" formControlName="Param1ProcOracle" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Param2ProcOracle</mat-label>
              <input matInput type="text" formControlName="Param2ProcOracle" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Param3ProcOracle</mat-label>
              <input matInput formControlName="Param3ProcOracle" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Param4ProcOracle</mat-label>
              <input matInput formControlName="Param4ProcOracle" />
            </mat-form-field>
          </div>
          <div class="user-field-container">
            <mat-form-field appearance="fill">
              <mat-label>Param5ProcOracle</mat-label>
              <input matInput type="text" formControlName="Param5ProcOracle" />
            </mat-form-field>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </form>
</div>
